export default __webpack_public_path__ + "static/media/BARTER.74cf2d40.png";